<div class="header">
  <div>
    <h2>{{ "pages.dozent.faqs.title" | translate }}</h2>
  </div>
  <app-dozent-filter-dropdown (changed)="onDozentScopeChange()"></app-dozent-filter-dropdown>
  <app-page-help>{{ "pages.dozent.faqs.subtitle" | translate }}</app-page-help>
</div>

<!-- Mirrors the Wissensbasis (knowledge-base) pattern: a single outer
     nb-card wraps the whole tab area, with `nb-tabset` directly as a
     child. Tables and empty states are flat (no inner nb-card) so we
     don't fall back into card-on-card (design.md §5 rule 1). -->
<nb-card class="faqs-card" alAnchor="dozent.faq-card">
  <nb-tabset (changeTab)="onTabChange($event.tabTitle)">
    <!-- Tab 1: FAQ / Wissen -->
    <nb-tab [tabTitle]="'pages.dozent.faqs.tabFaq' | translate" [active]="activeTab === 'faq'">
      <div class="tab-toolbar">
        <div class="tab-toolbar__left">
          <nb-form-field *ngIf="faqs.length > 0" class="toolbar-search">
            <input
              type="text"
              nbInput
              fieldSize="small"
              placeholder="{{ 'pages.dozent.faqs.searchPlaceholder' | translate }}"
              [(ngModel)]="searchText"
              (ngModelChange)="onFaqSearchChange()"
            />
            <button nbSuffix nbButton ghost size="small">
              @if (searchText && searchText.length > 0) {
                <nb-icon icon="close-outline" (click)="searchText = ''; onFaqSearchChange()"></nb-icon>
              } @else {
                <nb-icon icon="search-outline"></nb-icon>
              }
            </button>
          </nb-form-field>

          <nb-select
            placeholder="{{ 'pages.dozent.faqs.allDozentsFilter' | translate }}"
            (selectedChange)="onBotFilterChange($event)"
            size="small"
          >
            <nb-option [value]="undefined">
              {{ "pages.dozent.faqs.allDozentsFilter" | translate }}
            </nb-option>
            <nb-option *ngFor="let d of dozents" [value]="d.id">
              {{ d.visual_name || d.name }}
            </nb-option>
          </nb-select>

          <nb-select
            [selected]="statusFilter"
            (selectedChange)="onStatusFilterChange($event)"
            size="small"
          >
            <nb-option value="all">{{ "pages.dozent.faqs.statusAll" | translate }}</nb-option>
            <nb-option value="active">{{ "pages.dozent.faqs.active" | translate }}</nb-option>
            <nb-option value="inactive">{{ "pages.dozent.faqs.inactive" | translate }}</nb-option>
          </nb-select>

          <nb-toggle
            [checked]="groupByCategory"
            (checkedChange)="onGroupByCategoryChange($event)"
            size="small"
          >
            {{ "pages.dozent.faqs.groupByCategory" | translate }}
          </nb-toggle>
        </div>

        <div class="tab-toolbar__right">
          <app-pagination
            *ngIf="filteredFaqs.length > 0"
            class="table-pagination toolbar-pagination"
            [totalItems]="filteredFaqs.length"
            [itemsPerPage]="faqPageSize"
            [currentPage]="faqPage"
            [pageSizeOptions]="faqPageSizeOptions"
            (pageChanged)="onFaqPageChange($event)"
            (itemsPerPageChange)="onFaqPageSizeChange($event)"
          ></app-pagination>

          <div class="toolbar-menu-wrapper">
            <button
              nbButton
              status="primary"
              size="small"
              [class.is-open]="toolbarMenuOpen"
              alAnchor="dozent.faq-add"
              (click)="toggleToolbarMenu($event)"
            >
              <nb-icon icon="plus"></nb-icon>
              {{ "pages.dozent.faqs.addKnowledge" | translate }}
              <nb-icon
                class="caret"
                [icon]="toolbarMenuOpen ? 'chevron-up-outline' : 'chevron-down-outline'"
              ></nb-icon>
            </button>
            <div
              *ngIf="toolbarMenuOpen"
              class="toolbar-menu"
              (click)="$event.stopPropagation()"
            >
              <button type="button" class="toolbar-menu__item" alAnchor="dozent.faq-add-single" (click)="toolbarMenuOpen = false; openFaqDialog()">
                <nb-icon icon="plus-outline" pack="eva"></nb-icon>
                <span>{{ "pages.dozent.faqs.addKnowledge" | translate }}</span>
              </button>
              <button type="button" class="toolbar-menu__item" (click)="toolbarMenuOpen = false; downloadFaqTemplate()">
                <nb-icon icon="download-outline" pack="eva"></nb-icon>
                <span>{{ "pages.dozent.faqs.downloadTemplate" | translate }}</span>
              </button>
              <button
                type="button"
                class="toolbar-menu__item"
                [disabled]="importingFaqs"
                (click)="toolbarMenuOpen = false; faqCsvInput.click()"
              >
                <nb-icon icon="upload-outline" pack="eva"></nb-icon>
                <span>{{ (importingFaqs ? "pages.dozent.faqs.importing" : "pages.dozent.faqs.importCsv") | translate }}</span>
              </button>
            </div>
          </div>
          <input
            #faqCsvInput
            type="file"
            accept=".csv,text/csv"
            hidden
            (change)="onFaqCsvSelected($event)"
          />
        </div>
      </div>

      <app-page-loader *ngIf="isLoading"></app-page-loader>

      <!-- Empty state (flat — no inner card) -->
      <div
        *ngIf="!isLoading && filteredFaqs.length === 0"
        class="empty-state"
      >
        <nb-icon icon="book-open-outline" class="empty-icon"></nb-icon>
        <p>{{ "pages.dozent.faqs.empty" | translate }}</p>
        <button nbButton status="primary" alAnchor="dozent.faq-add-empty" (click)="openFaqDialog()">
          <nb-icon icon="plus"></nb-icon>
          {{ "pages.dozent.faqs.addKnowledge" | translate }}
        </button>
      </div>

      <!-- Grouped view -->
      <ng-container *ngIf="!isLoading && filteredFaqs.length > 0 && groupByCategory">
        <div *ngFor="let group of groupedFaqs" class="category-group">
          <div class="group-header" (click)="toggleGroup(group.category)">
            <nb-icon
              [icon]="collapsedGroups.has(group.category) ? 'chevron-right-outline' : 'chevron-down-outline'"
            ></nb-icon>
            <span class="group-label">{{ getCategoryLabel(group.category) }}</span>
            <span class="group-count">{{ group.faqs.length }}</span>
          </div>

          <div *ngIf="!collapsedGroups.has(group.category)" class="table-wrap">
            <table class="faq-table">
              <thead>
                <tr>
                  <th class="col-status"></th>
                  <th class="col-question">{{ "pages.dozent.faqs.question" | translate }}</th>
                  <th class="col-answer">{{ "pages.dozent.faqs.answer" | translate }}</th>
                  <th class="col-tutor">{{ "pages.dozent.faqs.assignDozent" | translate }}</th>
                  <th class="col-version">{{ "pages.dozent.faqs.version" | translate }}</th>
                  <th class="col-date">{{ "pages.dozent.faqs.createdAt" | translate }}</th>
                  <th class="col-date">{{ "pages.dozent.faqs.editedAt" | translate }}</th>
                  <th class="col-actions">{{ "words.actions" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let faq of group.faqs"
                  [class.inactive]="!faq.is_active"
                >
                  <td class="col-status">
                    <span
                      class="status-dot"
                      [class.active]="faq.is_active"
                      [nbTooltip]="faq.is_active ? ('pages.dozent.faqs.active' | translate) : ('pages.dozent.faqs.inactive' | translate)"
                    ></span>
                  </td>
                  <td class="col-question">
                    <span class="cell-text" [nbTooltip]="faq.question">{{ faq.question }}</span>
                  </td>
                  <td class="col-answer">
                    <span class="cell-text cell-answer" [nbTooltip]="faq.answer">{{ faq.answer }}</span>
                  </td>
                  <td class="col-tutor">
                    <span class="dozent-chips">
                      <span
                        *ngFor="let name of getDozentNames(faq)"
                        class="dozent-chip"
                      >{{ name }}</span>
                      <span *ngIf="getDozentNames(faq).length === 0" class="tutor-name">—</span>
                    </span>
                  </td>
                  <td class="col-version">{{ faq.version || '1.0' }}</td>
                  <td class="col-date">{{ faq.created_at | date: "dd.MM.yy" }}</td>
                  <td class="col-date">{{ faq.updated_at | date: "dd.MM.yy" }}</td>
                  <td class="col-actions">
                    <ng-container
                      [ngTemplateOutlet]="actionsMenu"
                      [ngTemplateOutletContext]="{ $implicit: faq }"
                    ></ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>

      <!-- Flat table view -->
      <div
        *ngIf="!isLoading && filteredFaqs.length > 0 && !groupByCategory"
        class="table-wrap"
      >
        <table class="faq-table">
          <thead>
            <tr>
              <th class="col-status"></th>
              <th class="col-question">{{ "pages.dozent.faqs.question" | translate }}</th>
              <th class="col-answer">{{ "pages.dozent.faqs.answer" | translate }}</th>
              <th class="col-category">{{ "pages.dozent.faqs.category" | translate }}</th>
              <th class="col-tutor">{{ "pages.dozent.faqs.assignDozent" | translate }}</th>
              <th class="col-version">{{ "pages.dozent.faqs.version" | translate }}</th>
              <th class="col-date">{{ "pages.dozent.faqs.createdAt" | translate }}</th>
              <th class="col-date">{{ "pages.dozent.faqs.editedAt" | translate }}</th>
              <th class="col-actions">{{ "words.actions" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let faq of pagedFaqs"
              [class.inactive]="!faq.is_active"
            >
              <td class="col-status">
                <span
                  class="status-dot"
                  [class.active]="faq.is_active"
                  [nbTooltip]="faq.is_active ? ('pages.dozent.faqs.active' | translate) : ('pages.dozent.faqs.inactive' | translate)"
                ></span>
              </td>
              <td class="col-question">
                <span class="cell-text" [nbTooltip]="faq.question">{{ faq.question }}</span>
              </td>
              <td class="col-answer">
                <span class="cell-text cell-answer" [nbTooltip]="faq.answer">{{ faq.answer }}</span>
              </td>
              <td class="col-category">
                <span class="category-pill">{{ getCategoryLabel(faq.category) }}</span>
              </td>
              <td class="col-tutor">
                <span class="dozent-chips">
                  <span
                    *ngFor="let name of getDozentNames(faq)"
                    class="dozent-chip"
                  >{{ name }}</span>
                  <span *ngIf="getDozentNames(faq).length === 0" class="tutor-name">—</span>
                </span>
              </td>
              <td class="col-version">{{ faq.version || '1.0' }}</td>
              <td class="col-date">{{ faq.created_at | date: "dd.MM.yy" }}</td>
              <td class="col-date">{{ faq.updated_at | date: "dd.MM.yy" }}</td>
              <td class="col-actions">
                <ng-container
                  [ngTemplateOutlet]="actionsMenu"
                  [ngTemplateOutletContext]="{ $implicit: faq }"
                ></ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </nb-tab>

    <!-- Tab 2: Dateien -->
    <nb-tab [tabTitle]="'pages.dozent.faqs.tabFiles' | translate">
      <div class="tab-toolbar">
        <div class="tab-toolbar__left">
          <button nbButton status="primary" size="small" (click)="openUploadDialog()">
            <nb-icon icon="upload-outline"></nb-icon>
            {{ "pages.dozent.faqs.uploadFiles" | translate }}
          </button>
          <button nbButton status="primary" size="small" appearance="outline" (click)="openCloudImportDialog()">
            <nb-icon icon="cloud-upload-outline"></nb-icon>
            {{ "pages.dozent.faqs.importFromCloud" | translate }}
          </button>
        </div>

        <nb-form-field *ngIf="knowledgeFiles.length > 0">
          <input
            type="text"
            nbInput
            fieldSize="small"
            placeholder="{{ 'pages.dozent.faqs.searchFilesPlaceholder' | translate }}"
            [(ngModel)]="fileSearchText"
            (ngModelChange)="onFileSearchChange()"
          />
          <button nbSuffix nbButton ghost size="small">
            @if (fileSearchText && fileSearchText.length > 0) {
              <nb-icon icon="close-outline" (click)="fileSearchText = ''; onFileSearchChange()"></nb-icon>
            } @else {
              <nb-icon icon="search-outline"></nb-icon>
            }
          </button>
        </nb-form-field>
        <app-pagination
          *ngIf="filteredFiles.length > 0"
          class="table-pagination toolbar-pagination"
          [totalItems]="filteredFiles.length"
          [itemsPerPage]="filePageSize"
          [currentPage]="filePage"
          [pageSizeOptions]="filePageSizeOptions"
          (pageChanged)="onFilePageChange($event)"
          (itemsPerPageChange)="onFilePageSizeChange($event)"
        ></app-pagination>
      </div>

      <app-page-loader *ngIf="isLoadingFiles"></app-page-loader>

      <!-- Empty state -->
      <div
        *ngIf="!isLoadingFiles && knowledgeFiles.length === 0"
        class="empty-state"
      >
        <nb-icon icon="file-text-outline" class="empty-icon"></nb-icon>
        <p>{{ "pages.dozent.faqs.filesEmpty" | translate }}</p>
        <div class="empty-actions">
          <button nbButton status="primary" (click)="openUploadDialog()">
            <nb-icon icon="upload-outline"></nb-icon>
            {{ "pages.dozent.faqs.uploadFiles" | translate }}
          </button>
          <button nbButton status="primary" appearance="outline" (click)="openCloudImportDialog()">
            <nb-icon icon="cloud-upload-outline"></nb-icon>
            {{ "pages.dozent.faqs.importFromCloud" | translate }}
          </button>
        </div>
      </div>

      <!-- Files table -->
      <div
        *ngIf="!isLoadingFiles && filteredFiles.length > 0"
        class="table-wrap"
      >
        <table class="faq-table files-table">
          <thead>
            <tr>
              <th class="col-file-name">{{ "pages.dozent.faqs.fileName" | translate }}</th>
              <th class="col-format">{{ "pages.dozent.faqs.fileFormat" | translate }}</th>
              <th class="col-size">{{ "pages.dozent.faqs.fileSize" | translate }}</th>
              <th class="col-file-status">{{ "words.status" | translate }}</th>
              <th class="col-source">{{ "pages.dozent.faqs.fileSource" | translate }}</th>
              <th class="col-date">{{ "pages.dozent.faqs.uploadedAt" | translate }}</th>
              <th class="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of pagedFiles">
              <td class="col-file-name">
                <div class="file-name-cell">
                  <nb-icon icon="file-text-outline" class="file-icon"></nb-icon>
                  <span class="cell-text" [nbTooltip]="file.file_name">{{ file.file_name }}</span>
                </div>
              </td>
              <td class="col-format">
                <span class="format-badge">{{ file.file_format }}</span>
              </td>
              <td class="col-size">{{ formatFileSize(file.file_size) }}</td>
              <td class="col-file-status">
                <span class="file-status-badge" [ngClass]="getFileStatusClass(file)"
                      [title]="getFileStatusTooltip(file)">
                  {{ getFileStatusLabel(file) }}
                </span>
              </td>
              <td class="col-source">
                <span *ngIf="file.cloud_source" class="source-badge cloud">{{ file.cloud_source }}</span>
                <span *ngIf="!file.cloud_source" class="source-badge local">Upload</span>
              </td>
              <td class="col-date">{{ file.uploaded_at | date: "dd.MM.yy" }}</td>
              <td class="col-actions">
                <div class="action-btns">
                  <button nbButton ghost size="tiny" status="danger" (click)="onDeleteFile(file)">
                    <nb-icon icon="trash-outline"></nb-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </nb-tab>
  </nb-tabset>
</nb-card>

<!-- Shared 3-dot row action menu for FAQ rows (grouped + flat views). -->
<ng-template #actionsMenu let-faq>
  <div class="row-action-wrapper">
    <button
      type="button"
      class="row-action-trigger"
      [class.is-open]="isFaqMenuOpen(faq)"
      [attr.aria-label]="'buttons.actions' | translate"
      (click)="toggleFaqMenu($event, faq)"
    >
      <nb-icon icon="more-vertical-outline" pack="eva"></nb-icon>
    </button>
    <div
      *ngIf="isFaqMenuOpen(faq)"
      class="row-action-menu"
      (click)="$event.stopPropagation()"
    >
      <button type="button" class="row-action-item" (click)="openFaqDialog(faq); closeFaqMenu()">
        <nb-icon icon="edit-outline" pack="eva"></nb-icon>
        <span>{{ "buttons.edit" | translate }}</span>
      </button>
      <button type="button" class="row-action-item" (click)="onToggleActive(faq); closeFaqMenu()">
        <nb-icon [icon]="faq.is_active ? 'eye-off-outline' : 'eye-outline'" pack="eva"></nb-icon>
        <span>{{ (faq.is_active ? "pages.dozent.faqs.deactivate" : "pages.dozent.faqs.activate") | translate }}</span>
      </button>
      <button
        type="button"
        class="row-action-item row-action-item--danger"
        (click)="onDeleteFaq(faq); closeFaqMenu()"
      >
        <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
        <span>{{ "buttons.delete" | translate }}</span>
      </button>
    </div>
  </div>
</ng-template>
